module.exports = __webpack_public_path__ + "static/img/air-freight-left.07fae78c.jpg";